import { useState } from 'react'

import { Box, Button, Flex } from 'app/components/design-system-components'
import Badge from 'app/components/design-system-components/Badges'
import SvgArrowForwardRounded from 'app/components/design-system-components/icons/navigation/ArrowForwardRounded'
import theme from 'app/match/applicationReportPDF/assets/theme'

export const STATUS_VERIFIED = 'verified'
export const STATUS_UNVERIFIED = 'unverified'
export const STATUS_CONFIRMED = 'confirmed'

function HeadingAndLabel({
  heading = '',
  status = STATUS_UNVERIFIED,
  isCopilot = false,
  showOpenViewerLink = false,
  toggleDocumentsViewer,
  fileName = '',
}: {
  heading?: string
  status?: string
  isCopilot?: boolean
  showOpenViewerLink?: boolean
  toggleDocumentsViewer?: (docGUID: string) => void
  fileName?: string
}) {
  let badgeVariant = 'green'
  let badgeText = 'Verified'

  if (!isCopilot) {
    switch (status) {
      case STATUS_UNVERIFIED:
        badgeVariant = 'warning'
        badgeText = 'Check'
        break
      case STATUS_VERIFIED:
        badgeVariant = 'green'
        badgeText = 'Verified'
        break
      case STATUS_CONFIRMED:
        badgeVariant = 'blue'
        badgeText = 'Confirmed'
        break
      default:
        badgeVariant = 'blue'
        badgeText = 'Confirmed'
        break
    }
  }

  if (isCopilot) {
    badgeVariant = 'warning'
    badgeText = 'Review'
  }

  const [style, setStyle] = useState({ display: 'none' })

  return (
    <Flex
      fontSize={theme.fontSizes.pRegular14}
      alignItems="center"
      fontWeight="700"
      onMouseEnter={() => {
        setStyle({ display: 'block' })
      }}
      onMouseLeave={() => {
        setStyle({ display: 'none' })
      }}
    >
      <Box>
        <Flex alignItems="center">
          <>{heading}</>
        </Flex>
      </Box>
      <Badge
        text={badgeText}
        variant={badgeVariant}
        fontSize={theme.fontSizes.pExtraSmall10}
        ml={3}
      />
      {showOpenViewerLink && (
        <Flex style={style} ml={3} alignItems="center">
          <Button
            variant="linkBlueWithoutWeight"
            onClick={toggleDocumentsViewer}
            fontWeight="400"
          >
            <Flex>
              <Box mr={3}>View {fileName}</Box>
              <SvgArrowForwardRounded
                height={theme.height[4] + 'px'}
                width={theme.width[4] + 'px'}
                ml={3}
              />
            </Flex>
          </Button>
        </Flex>
      )}
    </Flex>
  )
}

export default HeadingAndLabel
